<template>
  <QuestionPadding class="gabor-granger-question-presentation">
    <ChoiceSingle
      :fields="question.fields"
      :answers="answers"
      :selected-field-ids="selectedFieldIds"
      @answers-updated="$emit('answersUpdated', $event)"
    />
  </QuestionPadding>
</template>
<script lang="ts">
import { computed, type DeepReadonly, defineComponent, type PropType } from 'vue'

import type { Answer } from '../../../answer/models/Answer'
import ChoiceSingle from '../../../question-choice/components/dumb/ChoiceSingle.vue'
import QuestionPadding from '../../../question/components/dumb/QuestionPadding.vue'
import type { Question } from '../../../question/models/Question'

export default defineComponent({
  components: { QuestionPadding, ChoiceSingle },
  props: {
    question: {
      type: Object as PropType<DeepReadonly<Pick<Question<'gaborGranger'>, 'fields'>>>,
      required: true,
    },
    answers: {
      type: Array as PropType<DeepReadonly<Answer[]>>,
      required: true,
    },
  },
  emits: {
    answersUpdated: (_newAnswers: Answer[]) => true,
  },
  setup(props) {
    const selectedFieldIds = computed(
      () =>
        new Set(
          props.answers
            .filter((answer) => answer.type === 'choice' && answer.value.selected)
            .map((answer) => answer.fieldId),
        ),
    )

    return { selectedFieldIds }
  },
})
</script>
<style lang="postcss">
.gabor-granger-question-presentation {
  grid-template-rows: 1fr;
}
</style>
